// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1236":"0a29c316","3369":"0a29c316","4715":"0a29c316","7119":"1e875984","8560":"0a29c316"}[chunkId] + ".chunk.css";
};